import { useState } from 'react';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { Input } from './Input';
import { UploadField } from './UploadField';
import { AddAdditionalDocument } from './AddAdditionalDocument';
import { Transactions } from './Transactions';
import { DOC_DETAILS } from './data';
import s from './index.module.scss';

export const Form = ({ data, uploadErrors = {} }) => {
  const { t } = useTranslation();
  const { values, touched, errors, handleChange, setFieldValue, submitCount } =
    useFormikContext();

  const [visibleDocs, setVisibleDocs] = useState(
    data.documents?.required_documents?.filter(d => d.is_required).map(d => d.document_type) || [],
  );

  const requiredDocuments = data.documents?.required_documents?.filter(d => d.is_required).map(d => d.document_type) || [];

  return (
    <>
      <Transactions data={data.transactions} />
      {data.questionnaire && (
        <div className={s.group}>
          <div className={s.left}>
            <div className="f-small-accent">{data.questionnaire.title}</div>
            <div
              className="f-small-regular"
              style={{ color: 'var(--Grey-900-Deep, #52626F)' }}
            >
              {data.questionnaire.description}
            </div>
          </div>
          <div className={s.right}>
            <div className={s.groups}>
              {data.questionnaire.questions.map(item => (
                <Input
                  key={item.id}
                  label={item.is_required ? `${item.text} *` : item.text}
                  name={`questionnaire.${item.id}`}
                  placeholder={item.placeholder_text || ''}
                  onChange={handleChange}
                  value={values.questionnaire[item.id]}
                  error={
                    (touched.questionnaire?.[item.id] || submitCount > 0) &&
                    errors.questionnaire?.[item.id]
                  }
                  maxLength={item.max_length}
                />
              ))}
            </div>
          </div>
        </div>
      )}
      {data.questionnaire && data.documents && <div className={s.divider} />}
      {data.documents && (
        <div className={s.group}>
          <div className={s.left}>
            <div className="f-small-accent">{data.documents.title}</div>
            <div
              className="f-small-regular"
              style={{ color: 'var(--Grey-900-Deep, #52626F)' }}
            >
              {data.documents.description}
            </div>
          </div>
          <div className={s.right}>
            <div className={s.upload_groups}>
              {Object.keys(values.documents).map(type => {
                return (
                  DOC_DETAILS[type] &&
                  visibleDocs.includes(type) && (
                    <div key={type} className={s.upload}>
                      <div className="f-small-accent">
                        {`${t(`compliance:documents.${type.toLowerCase()}`)} ${requiredDocuments.includes(type) ? '*' : ''}`}
                      </div>
                      <UploadField
                        name={type}
                        value={values.documents[type]}
                        onChange={files =>
                          setFieldValue(`documents.${type}`, files)
                        }
                        error={
                          uploadErrors[type] ||
                          (submitCount > 0 && errors.documents?.[type])
                        }
                        allowedTypes={DOC_DETAILS[type].allowedTypes}
                        allowedSize={DOC_DETAILS[type].allowedSize}
                      />
                    </div>
                  )
                );
              })}
              <AddAdditionalDocument
                data={data}
                visibleDocs={visibleDocs}
                onSelect={option =>
                  setVisibleDocs([...visibleDocs, option.value])
                }
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};